<template>
	<div>
		<base-loader :show="isLoading"> </base-loader>
		<base-modal :show="!!error" title="An error occurred" @close="handleError">
			<p class="text-white">{{ error }}</p>
		</base-modal>
		<base-modal :show="notLoggedIn" title="Uh oh..." @close="close">
			<h3 class="text-white">Please log in or sign up to interact with posts</h3>
		</base-modal>
		<base-modal :show="showConfirmDelete" title="Delete?" @close="showConfirmDelete = false">
			<template v-slot:buttons>
				<button class="btn btn-outline-danger" @click="confirmedDeletePost">Delete</button>
			</template>
		</base-modal>

		<div class="row mt-5">
			<div class="col-md-8 mb-4">
				<div class="text-info" style="background-color: #212529">
					<div>
						<h1>Global Dugout Talk</h1>
						<!-- <div v-show="isLoading" class="mt-4 mb-4">
						<i class="fa-solid fa-baseball fa-spin fa-4x"></i>
					</div> -->
					</div>

					<div v-if="isLoading" class="card ms-4 me-4 mt-4 mb-4" aria-hidden="true">
						<div class="card-body" style="background-color: #263238">
							<h5 class="card-header placeholder-glow text-info text-start ps-0 pb-3">
								<span class="placeholder col-3"></span>
							</h5>
							<p class="card-text placeholder-glow text-info text-start mt-3 mb-3">
								<span class="placeholder col-12"></span>
								<span class="placeholder col-12"></span>
								<span class="placeholder col-4"></span>
								<span class="placeholder col-6"></span>
							</p>
							<div class="card-footer text-white-50">
								<div class="d-flex justify-content-between placeholder-glow">
									<span class="placeholder col-1"></span>
									<span class="placeholder col-1"></span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="getAllPosts.length < 1 && !isLoading" class="mt-5">
						<h4>A swing and a miss..no dugout chatter</h4>
					</div>
					<div v-if="!isLoading" class="card-body">
						<div
							v-for="post in getAllPosts.slice().reverse()"
							:key="post.id"
							class="card text-body mb-3 text-start"
							style="background-color: #263238"
						>
							<div class="card-header text-info">
								<div class="d-inline">
									{{ post.byUser }}
								</div>
								<div v-if="post.byUserId === userId" class="d-inline float-end">
									<a role="button" @click="confirmDeletePost(post.id)"
										><i class="fa-solid fa-xmark"></i
									></a>
								</div>
								<h6 class="card-subtitle mb-2 text-white-50">
									<small>{{ post.byUserLeague }}</small>
								</h6>
							</div>
							<div class="card-body">
								<h5 class="card-title text-info">{{ post.title }}</h5>
								<p class="card-text text-info">
									{{ post.message }}
								</p>
							</div>
							<div class="card-footer text-white-50">
								<div>
									<small>{{ posted(post.timeStamp) }}</small>
								</div>
								<div class="d-flex justify-content-between">
									<a
										class="text-info"
										@click="
											likePost(post.id, post.likes, post.dislikes, post.likedBy, post.dislikedBy)
										"
										role="button"
									>
										<div v-if="post.likedBy.some((user) => user === userId)">
											<i class="fa-solid fa-fire text-danger"></i>
											{{ post.likes }}
										</div>
										<div v-else>
											<i class="fa-solid fa-fire text-white-50"></i> {{ post.likes }}
										</div>
									</a>
									<a
										class="text-info"
										@click="
											dislikePost(
												post.id,
												post.dislikes,
												post.likes,
												post.likedBy,
												post.dislikedBy
											)
										"
										role="button"
									>
										<div v-if="post.dislikedBy.some((user) => user === userId)">
											<i class="fa-solid fa-dumpster-fire text-danger"></i>
											{{ post.dislikes }}
										</div>
										<div v-else>
											<i class="fa-solid fa-dumpster text-white-50"></i> {{ post.dislikes }}
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<div class="card text-info mb-4" style="background-color: #263238">
					<div class="card-header"><h3>Post to global</h3></div>
					<div class="card-body">
						<form v-if="isAuth" @submit.prevent="submitGlobalPostForm">
							<div class="form-outline text-start">
								<label for="title">Title</label>
								<input type="text" id="title" class="form-control" v-model.trim="title.val" />
							</div>
							<div class="form-outline mt-3 text-start">
								<label for="message">Message</label>
								<textarea
									class="form-control"
									id="message"
									rows="8"
									v-model.trim="message.val"
								></textarea>
							</div>
							<div class="d-grid mt-4">
								<button :disabled="isLoading" class="btn btn-outline-info btn-lg">
									<div v-show="isLoading">
										<i class="fa-solid fa-baseball fa-spin"></i>
										Posting...
									</div>
									<div v-show="!isLoading">Post</div>
								</button>
							</div>
						</form>
						<div v-else>
							<login-form @component-key="componentKey"></login-form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
moment().format();
import LoginForm from '../auth/LoginForm.vue';
export default {
	components: {
		LoginForm,
	},
	emits: ['component-key'],
	data() {
		return {
			user: null,
			title: {
				val: '',
				isValid: true,
			},
			message: {
				val: '',
				isValid: true,
			},
			comment: {
				val: '',
				isValid: true,
			},
			error: null,
			isLoading: false,
			showComments: '',
			notLoggedIn: false,
			showConfirmDelete: false,
			postDeleteId: null,
		};
	},
	created() {
		this.loadPosts();
		this.loadTeams();
	},
	computed: {
		getAllPosts() {
			return this.$store.getters['boards/getGlobalPosts'];
		},
		isAuth() {
			return this.$store.getters.isAuthenticated;
		},
		userId() {
			return this.$store.getters.userId;
		},
	},
	methods: {
		async likePost(id, likes, dislikes, likedByArr, dislikedByArr) {
			if (this.isAuth) {
				var likeCount = likes;
				var dislikeCount = dislikes;
				const userId = this.$store.getters.userId;
				const likeExists = likedByArr.some((user) => user === userId); // checks if logged in user already liked post
				const dislikeExists = dislikedByArr.some((user) => user === userId); // checks if logged in user disliked post
				if (!likeExists && dislikeExists) {
					// if not liked and is disliked by logged in user, adds user to like array, adds like count and removes dislike count and user from dislike array
					likedByArr.push(userId),
						(likeCount = likes + 1),
						(dislikeCount = dislikes - 1),
						(this.disableLike = true),
						(this.disableDislike = false);
				}
				if (!likeExists && !dislikeExists) {
					// if logged in user has not liked or disliked post adds to like array and adds like count
					likedByArr.push(userId), (likeCount = likes + 1);
				}
				const dislikedBy = dislikedByArr.filter((user) => user !== userId); // if user disliked post, creates new array without user and updates database with new array

				const payload = {
					id: id,
					likes: likeCount,
					dislikes: dislikeCount,
					likedBy: likedByArr,
					dislikedBy: dislikedBy,
				};
				try {
					await this.$store.dispatch('boards/globalPostLike', payload);
				} catch (err) {
					this.error = err.message || 'Try again.';
				}
				this.loadPosts();
			} else {
				this.notLoggedIn = true;
			}
		},
		async dislikePost(id, dislikes, likes, likedByArr, dislikedByArr) {
			if (this.isAuth) {
				var dislikeCount = dislikes;
				var likeCount = likes;
				const userId = this.$store.getters.userId;
				const dislikeExists = dislikedByArr.some((user) => user === userId); // opposite of like post
				const likeExists = likedByArr.some((user) => user === userId);
				if (!dislikeExists && likeExists) {
					dislikedByArr.push(userId), (dislikeCount = dislikes + 1), (likeCount = likes - 1);
					this.disableLike = false;
					this.disableDislike = true;
				} else if (!dislikeExists) {
					dislikedByArr.push(userId), (dislikeCount = dislikes + 1);
				}
				const likedBy = likedByArr.filter((user) => user !== userId);

				const payload = {
					id: id,
					dislikes: dislikeCount,
					likes: likeCount,
					likedBy: likedBy,
					dislikedBy: dislikedByArr,
				};

				try {
					await this.$store.dispatch('boards/globalPostDisLike', payload);
				} catch (err) {
					this.error = err.message || 'Try again.';
				}
				this.loadPosts();
			} else {
				this.notLoggedIn = true;
			}
		},
		async submitGlobalPostForm() {
			const payload = {
				title: this.title.val,
				message: this.message.val,
				timeStamp: moment().format(),
			};

			try {
				await this.$store.dispatch('boards/newGlobalPost', payload);
				this.title = '';
				this.message = '';
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
			this.loadPosts();
			this.loadNotifications();
		},
		confirmDeletePost(id) {
			this.showConfirmDelete = true;
			this.postDeleteId = id;
		},
		confirmedDeletePost() {
			this.deleteThisPost(this.postDeleteId);
			this.showConfirmDelete = false;
		},
		deleteThisPost(id) {
			this.$store.dispatch('boards/deleteGlobalPost', { id: id });
		},
		posted(timeStamp) {
			return moment(timeStamp).fromNow();
		},
		async loadTeams() {
			this.isLoading = true;
			try {
				await this.$store.dispatch('teams/fetchTeams');
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			setTimeout(() => {
				this.isLoading = false;
			}, 1500);
		},
		async loadPosts() {
			try {
				await this.$store.dispatch('boards/fetchGlobalPosts');
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
		},
		async loadNotifications() {
			try {
				await this.$store.dispatch('notifications/fetchNotifications');
			} catch (err) {
				this.error = err.message || 'Set user info failed... Try again.';
			}
		},
		close() {
			this.notLoggedIn = false;
		},
		handleError() {
			this.error = null;
		},
		componentKey() {
			this.isLoading = true;
			const payload = 1;
			this.$emit('component-key', payload);
			setTimeout(() => {
				this.isLoading = false;
			}, 1000);
		},
	},
};
</script>

<style scoped>
.card-skeleton {
	border: none;
	width: 400px;
	border-radius: 5px;
	overflow: hidden;
}

.inner-card {
	height: 20px;
	background-color: #eee;
}

.card-1 {
	height: 200px;
	background-color: #eee;
}

.card-2 {
	height: 130px;
}

.h-screen {
	height: 100vh;
}

.animate-pulse {
	animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
	50% {
		opacity: 0.9;
	}
}
.card-a {
	transform: translateX(300px);
	opacity: 0;
	transition: 150ms;
}
.card-show {
	transform: translateX(0);
	opacity: 1;
}
</style>
